import createLucideIcon from '../createLucideIcon';

const AlarmClock = createLucideIcon('AlarmClockIcon', [
  ['circle', { cx: '12', cy: '13', r: '8', key: '3y4lt7' }],
  ['path', { d: 'M12 9v4l2 2', key: '1c63tq' }],
  ['path', { d: 'M5 3 2 6', key: '18tl5t' }],
  ['path', { d: 'm22 6-3-3', key: '1opdir' }],
  ['path', { d: 'm6 19-2 2', key: '1ek6nb' }],
  ['path', { d: 'm18 19 2 2', key: 'lw9i' }],
]);

export default AlarmClock;
